import {handleResponse} from '../modules/responseMixed';
import {resetUnsavedChanges} from './unsavedChanges';
import {showFormFieldError} from './showFormFieldError';
import {
    loadingButton,
    restoreLoadingButton,
    getLoadingButtonText
} from '../../../end_user_ui/assets/js/utilities/loadingButton';

let isFormSubmitting = false;

const formSubmit = async (e) => {
    const form = e.target;

    // Ignore forms that purely close dialogs via `method="dialog"`
    if (form.method === 'dialog') {
        return;
    }

    const isFileUpload = form.getAttribute('data-is-file-upload');
    const isEndUserForm = form.getAttribute('data-kinde-form'); // NOTE: This will be used everywhere eventually
    const isMakeForm = form?.closest('[data-kui-chat-prompt]');

    if (form) {
        e.preventDefault();
    }

    resetUnsavedChanges();

    /* Prevent multiple submissions */
    if (isFormSubmitting) {
        return false;
    }

    isFormSubmitting = true;

    // Factor in forms submitted by remote buttons
    const submitButton = isFileUpload
        ? form.querySelector('[data-kui-file-upload-trigger]')
        : e.submitter || form.querySelector('button[type="submit"]');

    const liveRegion = submitButton.nextElementSibling;
    const submitButtonText = getLoadingButtonText(submitButton);

    if (isEndUserForm) {
        loadingButton(submitButton);
    } else {
        form.classList.add('is-loading');
        submitButton.classList.add('is-loading');

        if (liveRegion) {
            liveRegion.textContent = isFileUpload
                ? 'File is uploading'
                : isMakeForm
                  ? 'Response from Kinde in progress. Press ENTER to stop the response.'
                  : 'Form submitting';
        }
    }

    const formData = new FormData(form);

    const searchParams = new URLSearchParams();
    for (const [key, value] of searchParams.entries()) {
        formData.append(key, value);
    }

    if (submitButton.getAttribute('name')) {
        formData.append(
            submitButton.getAttribute('name'),
            submitButton.getAttribute('value')
        );
    }

    const path = form.action;
    const csrfToken = document.head.querySelector(
        '[name=csrf-token][content]'
    ).content;

    let responseType;

    try {
        const response = await fetch(path, {
            method: form.method,
            body: formData,
            redirect: 'error',
            headers: {
                Accept: 'roast/mixed',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-Token': csrfToken,
                'X-Client-Time': Date.now()
            }
        });

        responseType = await handleResponse(response);
    } catch (error) {
        if (isEndUserForm) {
            restoreLoadingButton(submitButton, submitButtonText);
        } else {
            resetFormLoading(submitButton);
            showFormFieldError(form, error);
        }
    } finally {
        // Means forms can't be resubmitted whilst redirect takes place
        if (responseType !== 'redirect') {
            isFormSubmitting = false;
        }
    }
};

const resetFormLoading = (submitButton) => {
    const liveRegion = submitButton.nextElementSibling;
    submitButton.form.classList.remove('is-loading');
    submitButton.classList.remove('is-loading');
    liveRegion.textContent = '';
};

export {formSubmit, resetFormLoading};
